import React, {useState, useEffect} from 'react'
import gql from 'graphql-tag'
import { useLazyQuery, useMutation } from '@apollo/react-hooks'
import { Button, notification } from 'antd'

import Layout from 'components/PrivateRoutes/Layout'
import DatePicker from 'components/shared/DatePicker'
import InvoiceTable from './InvoiceTable'

const ServiceProviderQuery = gql`
  query ServiceProviderQuery($from: Date, $to: Date) {
      serviceProvider {
        id
        invoices(from: $from, to: $to) {
          id
          invoiceNumber
          sumTotal
          pdf
          includesLinesOn
        }
      }
    }
`

const DownloadServiceProviderInvoicesMutation = gql`
  mutation DownloadServiceProviderInvoicesMutation($from: Date!, $to: Date!) {
    DownloadServiceProviderInvoices(from: $from, to: $to){
      downloadUrl
    }
  }
`

const Invoices = (props : any) => {
  const [getServiceProvider, { loading, data }] = useLazyQuery(ServiceProviderQuery)
  const [downloadServiceProviderInvoices, { loading: downloading, data: downloadData, error: downloadError }] = useMutation(DownloadServiceProviderInvoicesMutation)
  const [dateRange, setDateRange] = useState<{ from: Date, to: Date }>()
  const invoices = data?.serviceProvider.invoices || []

  useEffect(() => {
    if (downloadError) {
      notification.error({
        message: 'Nedlastning feilet',
        description: 'Kunne ikke laste ned ZIP-fil grunnet en feil. Forsøk på nytt senere.',
      })
    } else if (downloadData) {
      window.location = downloadData['DownloadServiceProviderInvoices'].downloadUrl
    }
  }, [downloading, downloadData, downloadError])

  return (
    <Layout {...props} title="Fakturaer">
      <DatePicker 
        loading={loading}
        onSubmit={(dateRange : [Date, Date]) => {
          const [from, to] = dateRange
          setDateRange({ from, to })
          getServiceProvider({
            variables: { from, to }
          })
        }}
      />
      <Button
        loading={downloading}
        disabled={invoices.length < 1}
        onClick={() => downloadServiceProviderInvoices({ variables: dateRange })}>
        Last ned alle faktura som PDF
      </Button>
      <InvoiceTable loading={loading} invoices={invoices}/>
    </Layout> 
  )
}

export default Invoices
